import {RootState} from '../rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const specialistAdminDashboardStatus = createSelector(
  [(state: RootState) => state.specialistAdmin.isLoading],
  isLoading => isLoading,
);

export const specialistAdminDashboardSuccessSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.specialistAdminDashboardSuccess],
  specialistAdminDashboardSuccess => specialistAdminDashboardSuccess,
);

export const specialistAdminDashboardFailureSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.specialistAdminDashboardFailure],
  specialistAdminDashboardFailure => specialistAdminDashboardFailure,
);

export const specialistAdminDashboardConsultationsSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.dashboard?.consultations],
  consultations => consultations || [],
);

export const specialistAdminDashboardCurrentPageSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.dashboard?.current_page],
  currentPage => currentPage ?? 0,
);

export const specialistAdminDashboardTotalPagesSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.dashboard?.total_pages],
  totalPages => totalPages ?? 0,
);

export const specialistAdminDashboardTotalResultsSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.dashboard?.total_results],
  totalResults => totalResults ?? 0,
);

export const specialistAdminDashboardNextPageSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.dashboard?.next_page],
  nextPage => nextPage ?? null,
);

// Specialist Onboarding List Selectors
export const specialistOnboardingListSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.onboarding?.specialists],
  specialists => specialists || [],
);

export const specialistOnboardingCurrentPageSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.onboarding?.current_page],
  currentPage => currentPage ?? 0,
);

export const specialistOnboardingTotalPagesSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.onboarding?.total_pages],
  totalPages => totalPages ?? 0,
);

export const specialistOnboardingTotalResultsSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.onboarding?.total_results],
  totalResults => totalResults ?? 0,
);

// Specialist Admin Profile Selectors
export const specialistAdminProfileSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.profile],
  profile => profile,
);

// Hospital List Selectors
export const hospitalListSelector = createSelector(
  [(state: RootState) => state.specialistAdmin.hospitals],
  hospitals => hospitals || [],
);